var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWind(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "230mm",
    height: "230mm",
    viewBox: "0 0 230 230",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("marker", {
    id: "marker19",
    overflow: "visible",
    markerHeight: 1,
    markerWidth: 1,
    orient: "auto-start-reverse",
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 1 1"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "scale(.5)",
    d: "m5.77 0-8.65 5v-10z",
    fill: "context-stroke",
    fillRule: "evenodd",
    stroke: "context-stroke",
    strokeWidth: "1pt"
  })), /*#__PURE__*/React.createElement("marker", {
    id: "Triangle",
    overflow: "visible",
    markerHeight: 1,
    markerWidth: 1,
    orient: "auto-start-reverse",
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 1 1"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "scale(.5)",
    d: "m5.77 0-8.65 5v-10z",
    fill: "context-stroke",
    fillRule: "evenodd",
    stroke: "context-stroke",
    strokeWidth: "1pt"
  })), /*#__PURE__*/React.createElement("marker", {
    id: "Triangle-4",
    overflow: "visible",
    markerHeight: 1,
    markerWidth: 1,
    orient: "auto-start-reverse",
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 1 1"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "scale(.5)",
    d: "m5.77 0-8.65 5v-10z",
    fill: "context-stroke",
    fillRule: "evenodd",
    stroke: "context-stroke",
    strokeWidth: "1pt"
  })), /*#__PURE__*/React.createElement("marker", {
    id: "marker19-0",
    overflow: "visible",
    markerHeight: 1,
    markerWidth: 1,
    orient: "auto-start-reverse",
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 1 1"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "scale(.5)",
    d: "m5.77 0-8.65 5v-10z",
    fill: "context-stroke",
    fillRule: "evenodd",
    stroke: "context-stroke",
    strokeWidth: "1pt"
  })), /*#__PURE__*/React.createElement("marker", {
    id: "Triangle-2",
    overflow: "visible",
    markerHeight: 1,
    markerWidth: 1,
    orient: "auto-start-reverse",
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 1 1"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "scale(.5)",
    d: "m5.77 0-8.65 5v-10z",
    fill: "context-stroke",
    fillRule: "evenodd",
    stroke: "context-stroke",
    strokeWidth: "1pt"
  })), /*#__PURE__*/React.createElement("marker", {
    id: "marker19-6",
    overflow: "visible",
    markerHeight: 1,
    markerWidth: 1,
    orient: "auto-start-reverse",
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 1 1"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "scale(.5)",
    d: "m5.77 0-8.65 5v-10z",
    fill: "context-stroke",
    fillRule: "evenodd",
    stroke: "context-stroke",
    strokeWidth: "1pt"
  })), /*#__PURE__*/React.createElement("marker", {
    id: "Triangle-7",
    overflow: "visible",
    markerHeight: 1,
    markerWidth: 1,
    orient: "auto-start-reverse",
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 1 1"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "scale(.5)",
    d: "m5.77 0-8.65 5v-10z",
    fill: "context-stroke",
    fillRule: "evenodd",
    stroke: "context-stroke",
    strokeWidth: "1pt"
  })), /*#__PURE__*/React.createElement("marker", {
    id: "marker19-4",
    overflow: "visible",
    markerHeight: 1,
    markerWidth: 1,
    orient: "auto-start-reverse",
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 1 1"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "scale(.5)",
    d: "m5.77 0-8.65 5v-10z",
    fill: "context-stroke",
    fillRule: "evenodd",
    stroke: "context-stroke",
    strokeWidth: "1pt"
  })), /*#__PURE__*/React.createElement("marker", {
    id: "Triangle-7-6",
    overflow: "visible",
    markerHeight: 1,
    markerWidth: 1,
    orient: "auto-start-reverse",
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 1 1"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "scale(.5)",
    d: "m5.77 0-8.65 5v-10z",
    fill: "context-stroke",
    fillRule: "evenodd",
    stroke: "context-stroke",
    strokeWidth: "1pt"
  })), /*#__PURE__*/React.createElement("marker", {
    id: "marker19-4-4",
    overflow: "visible",
    markerHeight: 1,
    markerWidth: 1,
    orient: "auto-start-reverse",
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 1 1"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "scale(.5)",
    d: "m5.77 0-8.65 5v-10z",
    fill: "context-stroke",
    fillRule: "evenodd",
    stroke: "context-stroke",
    strokeWidth: "1pt"
  })), /*#__PURE__*/React.createElement("marker", {
    id: "Triangle-5",
    overflow: "visible",
    markerHeight: 1,
    markerWidth: 1,
    orient: "auto-start-reverse",
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 1 1"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "scale(.5)",
    d: "m5.77 0-8.65 5v-10z",
    fill: "context-stroke",
    fillRule: "evenodd",
    stroke: "context-stroke",
    strokeWidth: "1pt"
  })), /*#__PURE__*/React.createElement("marker", {
    id: "marker19-8",
    overflow: "visible",
    markerHeight: 1,
    markerWidth: 1,
    orient: "auto-start-reverse",
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 1 1"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "scale(.5)",
    d: "m5.77 0-8.65 5v-10z",
    fill: "context-stroke",
    fillRule: "evenodd",
    stroke: "context-stroke",
    strokeWidth: "1pt"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 87.062,
    cy: 114.84,
    rx: 7.9375,
    ry: 7.9375
  }), /*#__PURE__*/React.createElement("path", {
    d: "m86.783 123.03-0.79375 7.9375 13.229 5.2917 23.283-7.6729"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m85.99 130.97 10.319 10.848 10.583-13.229"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m85.99 130.97-2.6458 23.813 10.583 13.229 5.2917 21.167"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m83.344 154.78-5.2917 13.229-5.2917 21.167"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m98.969 128.57h47.625"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m102.26 93.087c1.2047 0.82389 28.531 30.038 52.917 0 20.783-25.601 48.092-6.3892 52.917 0",
    markerEnd: "url(#marker19-4)",
    markerMid: "url(#Triangle-7)",
    stroke: "#0023ff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m161.02 158.96a76.729 52.917 0 0 1 0.17079-61.447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m161.57 112.45a19.844 12.704 0 0 1 0.0442-14.752"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m161.35 128.32a19.844 13.671 0 0 1 0.0442-15.875"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m161.31 145.22a19.844 14.552 0 0 1 0.0442-16.898"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m161.02 158.96a19.844 12.06 0 0 1 0.0442-14.005"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m146.84 128.28a13.891 15.977 0 0 1 4.3302-11.444 13.891 15.977 0 0 1 10.165-4.3705"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m146.59 128.57c13.967-0.25 14.008-0.25 14.008-0.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m160.87 145a13.432 16.605 0 0 1-9.8275-4.5322 13.432 16.605 0 0 1-4.1954-11.885"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m151.22 80.647 24.933-6.4878",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m2.8988 51.546c0.96367 0.97452 28.531 30.038 52.917 0 20.783-25.601 48.092-6.3892 52.917 0",
    markerEnd: "url(#marker19-8)",
    markerMid: "url(#Triangle-5)",
    stroke: "#0023ff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m102.26 56.045c1.2047 0.82388 28.531 30.038 52.917 0 20.783-25.601 48.092-6.3892 52.917 0",
    markerEnd: "url(#marker19-4-4)",
    markerMid: "url(#Triangle-7-6)",
    stroke: "#0023ff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m88.635 104.51h21.167c21.167 0 28.616-16.311 31.75-26.458 2.1464-6.9488 1.0061-17.529-5.2917-21.167-5.5599-3.2112-18.521-5.2917-18.521 5.2917 1e-5 7.9375 1e-5 18.521 30.427 18.521",
    stroke: "#000",
    strokeDasharray: "2.1, 2.1",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "m156.1 79.375-1.6657-6.4014 15.121-3.9347 1.6657 6.4014",
    stroke: "#000"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#0023ff",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m14.552 96.573c0.96367 0.97452 28.531 30.038 52.917 0 20.783-25.601 48.092-6.3892 52.917 0",
    markerEnd: "url(#marker19)",
    markerMid: "url(#Triangle)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m109.8 165.36c3.0061 2.5573 28.907 30.07 52.917 0 20.574-25.768 48.092-6.3892 52.917 0",
    markerEnd: "url(#marker19-0)",
    markerMid: "url(#Triangle-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.552 157.43c0.97886 1.1913 28.531 30.038 52.917 0 20.783-25.601 48.092-6.3892 52.917 0",
    markerEnd: "url(#marker19-6)",
    markerMid: "url(#Triangle-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m9.2604 191.82h211.67",
    stroke: "#000",
    strokeWidth: 2.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWind);
export default __webpack_public_path__ + "static/media/wind.f9c5f87140c7b46e3a0c05de60fc013b.svg";
export { ForwardRef as ReactComponent };